/* eslint-disable max-len */
import { ApolloError } from '@apollo/client';
import { getProspectOutput } from '../../../../api';
import { manageCodeLabelColumns } from '../../../../components';
import { prospect } from '../../../../entityModel';
import { ManageProspectsTableBody } from './ManageProspectTableBody';
import { ManageProspectsTableHead } from './ManageProspectTableHead';

interface ManageProspectsTableProps {
  error?: ApolloError;
  loading: boolean;
  data?: getProspectOutput;
  onEdit: (prospect: prospect) => void;
  onDelete: (prospect: prospect) => void;
}

export const ManageProspectsTable = ({ error, loading, data, onEdit, onDelete, ...rest }: ManageProspectsTableProps) => {
  return (
    <table className="table table-bordered">
      <ManageProspectsTableHead
        columns={manageCodeLabelColumns}
      />
      <ManageProspectsTableBody
        columns={manageCodeLabelColumns}
        loading={loading}
        error={error}
        data={data}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    </table>
  );
};
